import React from "react";
import ValidSvg from "../../../svg/ValidSvg.svg";
import NotValidSvg from "../../../svg/NotsureSvg.svg";
import InvaliSvg from "../../../svg/InvalidSvg.svg";
import ToxicSvg from "../../../svg/ToxicSvg.svg";

function ReactionButton({ cm, likes }) {
  return (
    <div className="reactions justify-content-end d-flex flex-wrap align-items-center gap-2">
      <span>{likes?.length || cm?.likes.length}</span>
      {cm?.reactionCount?.validCount !== 0 && (
        <div className="forum_valid pointer ">
          <img src={ValidSvg} alt="" className="pe-2" />{" "}
          {cm?.reactionCount?.validCount}
        </div>
      )}

      {cm?.reactionCount?.invalidCount !== 0 && (
        <div
          className="forum_valid pointer "
          style={{
            backgroundColor: "rgba(236, 128, 128, 1)",
          }}
        >
          <img src={InvaliSvg} alt="" className="pe-2" />
          {cm?.reactionCount?.invalidCount}
        </div>
      )}

      {cm?.reactionCount?.NotSureCount !== 0 && (
        <div className="forum_valid bg-warning pointer ">
          <img src={NotValidSvg} alt="" className="pe-2" />
          {cm?.reactionCount?.NotSureCount}
        </div>
      )}

      {cm?.reactionCount?.toxicCount !== 0 && (
        <div
          className="forum_valid pointer "
          style={{
            backgroundColor: "rgba(152, 120, 206, 1)",
          }}
        >
          <img src={ToxicSvg} alt="" className="pe-2" />
          {cm?.reactionCount?.toxicCount}
        </div>
      )}
    </div>
  );
}

export default ReactionButton;
